import { DetailsEditor, Divider } from "uikit"
import React from "react"
import { Redirect } from "react-router-dom"
import { Button, Grid, Icon } from "semantic-ui-react"
import { useStore } from "store"
import HouseholdsTable from "./HouseholdTable"
import SearchBar from "./SearchBar"

const HouseholdIcon = () => (
  <div style={{ paddingTop: "1.5em" }}>
    <Icon name="address book outline" size="huge" color="grey" />
  </div>
)

class HouseholdBrowserBody extends React.Component {
  constructor(props) {
    super()
    const houseHolds = props.households
    const householdsCount = houseHolds.length
    const defaultCount = 10
    const householdTitle =
      householdsCount > defaultCount
        ? "RECENT HOUSEHOLDS (" + defaultCount + " of " + householdsCount + " )"
        : "HOUSEHOLDS"
    const showSearch = householdsCount > defaultCount ? true : false
    const remainingHouseholdsCount = householdsCount - defaultCount
    const additionalHouseholdsText = showSearch
      ? remainingHouseholdsCount > 1
        ? remainingHouseholdsCount + " households not shown, but searchable."
        : remainingHouseholdsCount + " household not shown, but searchable."
      : ""
    const currentHousehold = houseHolds.filter(
      household => household.id === props.currentHouseholdId
    )
    const otherHouseholds = houseHolds.filter(
      household => household.id !== props.currentHouseholdId
    )
    const filteredHouseholds = currentHousehold.concat(otherHouseholds)
    this.state = {
      filterHouseholds: filteredHouseholds.slice(0, defaultCount),
      householdTitle: householdTitle,
      showSearchbox: showSearch,
      searchValue: "",
      additionalHouseholdsText: additionalHouseholdsText
    }
  }

  onHouseholdCreate = async values => {
    await this.props.createHousehold(values)
    this.onHouseholdSearch(this.state.searchValue)
  }
  onHouseholdSearch = searchValue => {
    let houseHolds = this.props.households
    const currentHousehold = houseHolds.filter(
      household => household.id === this.props.currentHouseholdId
    )
    const otherHouseholds = houseHolds.filter(
      household => household.id !== this.props.currentHouseholdId
    )
    const allHouseholds = currentHousehold.concat(otherHouseholds)
    this.setState({
      searchValue: searchValue
    })
    const defaultCount = 10
    let searchTitle = ""
    const emptyDescriptionText = "NEW HOUSEHOLD"
    const searchedList =
      searchValue !== ""
        ? allHouseholds.filter(
            household =>
              (household.description === "" &&
                emptyDescriptionText
                  .toLowerCase()
                  .includes(searchValue.toLowerCase())) ||
              household.description
                .toLowerCase()
                .includes(searchValue.toLowerCase())
          )
        : allHouseholds
    const searchListCount = searchedList.length
    if (searchValue !== "") {
      searchTitle = searchListCount + " Matching Households"
    } else {
      searchTitle =
        searchListCount > defaultCount
          ? "RECENT Households (" +
            defaultCount +
            " of " +
            searchListCount +
            " )"
          : "HOUSEHOLDS"
    }
    const remainingHouseholdsCount = searchListCount - defaultCount
    const additionalHouseholdsText =
      searchListCount > defaultCount && searchValue === ""
        ? remainingHouseholdsCount > 1
          ? remainingHouseholdsCount + " households not shown, but searchable."
          : remainingHouseholdsCount + " household not shown, but searchable."
        : ""

    const newHouseholdList =
      searchValue === "" ? searchedList.slice(0, defaultCount) : searchedList
    this.setState({
      filterHouseholds: newHouseholdList,
      householdTitle: searchTitle,
      additionalHouseholdsText: additionalHouseholdsText
    })
  }
  render() {
    const { setCurrentHousehold, currentHouseholdId, currentUser } = this.props
    return (
      <Grid textAlign="center">
        <SearchBar
          createHousehold={this.onHouseholdCreate}
          setCurrentHousehold={setCurrentHousehold}
          currentUser={currentUser}
          onSearch={this.onHouseholdSearch}
          showSearch={this.state.showSearchbox}
        />
        <Divider label={this.state.householdTitle} />
        <HouseholdsTable
          {...{
            households: this.state.filterHouseholds,
            setCurrentHousehold,
            currentHouseholdId
          }}
        />
        {this.state.additionalHouseholdsText ? (
          <p
            style={{
              color: "#aaaaaa",
              minHeight: "3.4em",
              lineHeight: "3.4285em",
              fontWeight: "600"
            }}
          >
            {this.state.additionalHouseholdsText}
          </p>
        ) : null}
      </Grid>
    )
  }
}

class HouseholdBrowserContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      switchedHousehold: false
    }
  }
  render = () => {
    if (this.state.switchedHousehold) {
      return <Redirect to="/organize" />
    }
    const {
      households,
      setCurrentHousehold,
      currentHouseholdId,
      createHousehold,
      canCreateHousehold,
      currentUser
    } = this.props
    // const canCreateHousehold = currentUser.hasPrivilege('household:create')
    return (
      <Grid className="white">
        <Grid.Row>
          <Grid.Column>
            <DetailsEditor
              iconImage={HouseholdIcon}
              heading="Households"
              description={
                "The household serves as the fundamental unit of organization. A household consists of at least a client, but may also have a spouse and children. All assets, incomes and goals are associated with a household."
              }
            >
              <HouseholdBrowserBody
                {...{
                  households,
                  setCurrentHousehold,
                  currentHouseholdId,
                  createHousehold: canCreateHousehold ? createHousehold : false,
                  currentUser
                }}
              />
            </DetailsEditor>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row style={{ borderTop: "1px solid #ccc" }}>
          <Grid.Column textAlign="right" style={{ paddingRight: "2em" }}>
            <Button
              content="Done"
              onClick={() => this.setState({ switchedHousehold: true })}
              primary
              type="button"
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

const HouseholdsBrowser = ({
  setCurrentHousehold,
  currentHouseholdId,
  createHousehold,
  canCreateHousehold,
  user
}) => {
  const [households] = useStore("currentUserHouseholds")
  return (
    <HouseholdBrowserContainer
      {...{
        canCreateHousehold,
        households,
        currentUser: user,
        setCurrentHousehold,
        currentHouseholdId,
        createHousehold
      }}
    />
  )
}

export default HouseholdsBrowser
